const PredefinedValidators = {
  required: {
    validate: (value) => value || (value === 0),
    message: (value, editor) => {
      const { label } = editor;
      return `${label} must be defined`;
    },
  },
  min: {
    parse: (minValue) => {
      // Min value is provided with an accessor to the data
      if (typeof minValue === 'string') {
        return (value, editor, data) => {
          const dataMin = data[minValue];
          return (dataMin === undefined) || (value >= dataMin);
        };
      }
      return value => (value >= minValue);
    },
    message: (value, min) => `${value} must be lower or equal to ${min}`,
  },
  max: {
    validate: (value, maxValue) => value <= maxValue,
    parse: (maxValue) => {
      // Min value is provided with an accessor to the data
      if (typeof maxValue === 'string') {
        return (value, editor, data) => {
          const dataMax = data[maxValue];
          return (dataMax === undefined) || (value <= dataMax);
        };
      }
      return value => (value <= maxValue);
    },
    message: (value, max) => `${value} must be greater or equal to ${max}`,
  },
};

const parseValidator = (v) => {
  if ((typeof v === 'string') || Array.isArray(v)) {
    const [name, message, ...params] = Array.isArray(v) ? v : [v];
    const pd = PredefinedValidators[name];
    if (!pd) {
      console.error(`Unkown validator ${name}`);
      return null;
    }
    if (pd.parse) {
      const vd = pd.parse(...params);
      return (value, editor, data, props) => {
        if (!vd(value, editor, data, props)) {
          return message || pd.message(value, ...params, editor, data, props);
        }
        return null;
      };
    }
    return (value, editor, data, props) => {
      if (!pd.validate(value, ...params, editor, data, props)) {
        return message || pd.message(value, ...params, editor, data, props);
      }
      return null;
    };
  }
  return v;
};

export { parseValidator, PredefinedValidators };
